import api from './api';
import { API_ENDPOINTS } from './config';

/**
 * Equipment Service
 * Handles all equipment-related API calls including CRUD operations, assignments, and location-based queries
 */

/**
 * Fetch all equipment
 * @returns {Promise<Object>} { success, data: [equipment items], error }
 */
export const getAllEquipment = async (limit = 50, page = 1) => {
  try {
    // Construct the query parameters for limit and page
    const response = await api.get(API_ENDPOINTS.EQUIPMENT.GET_ALL, {
      params: { limit, page }, // Include limit and page in the query
    });
    return response;
  } catch (error) {
    console.error('Get All Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment',
    };
  }
};


export const deleteMyEquipment = async (equipmentId) => {
  try {
    const response = await api.delete(`${API_ENDPOINTS.CREATOR.DELETE_EQUIPMENT}/${equipmentId}`);
    return response;
  } catch (error) {
    console.error('Delete Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to delete equipment',
    };
  }
};

/**
 * Fetch equipment by ID
 * @param {number|string} equipmentId - The equipment ID
 * @returns {Promise<Object>} { success, data: equipment object, error }
 */
export const getEquipmentById = async (equipmentId) => {
  try {
    const response = await api.get(`${API_ENDPOINTS.EQUIPMENT.GET_BY_ID}/${equipmentId}`);
    return response;
  } catch (error) {
    console.error('Get Equipment By ID Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment details',
    };
  }
};


export const getCrewAvailability = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.CREW_AVAILABILITY, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Crew Availability Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch crew availability',
    };
  }
};


export const AddAvailability = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.ADD_AVAILABILITY, payload, {
      headers: {
        'Content-Type': 'application/json',  // Use 'application/json' instead of 'multipart/form-data'
      },
    });
    return response;
  } catch (error) {
    console.error('Get Crew Availability Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch crew availability',
    };
  }
};

export const getProjectDetails = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.GET_PROJECT_DETAILS, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};


export const getCrewEquipment = async (payload) => {
  try {
    const response = await api.get(API_ENDPOINTS.CREATOR.GET_CREW_EQUIPMENT, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};

export const getallEquipment = async (payload) => {
  try {
    const response = await api.get(API_ENDPOINTS.CREATOR.GET_ALL_EQUIPMENT, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};

export const editProfile = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.EDIT_MY_DETAILS, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};


export const getCrewEquipmentCount = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.GET_CREW_EQUIPMENT_COUNT, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};


export const getMyProfile = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.GET_MY_DETAILS, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Project Details Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch project details',
    };
  }
};
/**
 * Fetch dashboard statistics
 * @param {number|string} creatorId - The creator/crew member ID
 * @returns {Promise<Object>} { success, data: dashboard stats, error }
 */
export const getDashboardCount = async (creatorId) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.DASHBOARD_COUNT, {
      creator_id: creatorId
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Dashboard Count Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch dashboard statistics',
    };
  }
};

/**
 * Fetch pending projects for crew member
 * @param {number|string} crewMemberId - The crew member ID
 * @returns {Promise<Object>} { success, data: pending projects, error }
 */
export const getPendingProjects = async (crewMemberId) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.PENDING_PROJECTS, {
      crew_member_id: crewMemberId
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Pending Projects Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch pending projects',
    };
  }
};

/**
 * Accept or decline a project
 * @param {number|string} crewMemberId - The crew member ID
 * @param {number|string} projectId - The project ID
 * @param {number} crewAccept - 1 for accept, 2 for decline
 * @returns {Promise<Object>} { success, data: response data, error }
 */
export const acceptOrDeclineProject = async (projectId, crewAccept) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.ACCEPT_PROJECT, {
      project_id: projectId,
      crew_accept: crewAccept
    }, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response;
  } catch (error) {
    console.error('Accept/Decline Project Error:', error);
    return { success: false, error: 'Failed to process request' };
  }
};


export const GetUpcomingShoots = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.UPCOMING_SHOOTS, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Crew Availability Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch crew availability',
    };
  }
};

/**
 * Update existing equipment
 * @param {number|string} equipmentId - The equipment ID
 * @param {FormData|Object} data - Equipment update data (FormData for file uploads, Object otherwise)
 * @returns {Promise<Object>} { success, data: updated equipment, error }
 */
export const updateEquipment = async (equipmentId, data) => {
  try {
    const isFormData = data instanceof FormData;
    const config = isFormData
      ? {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
      : {};

    const response = await api.put(`${API_ENDPOINTS.EQUIPMENT.UPDATE}/${equipmentId}`, data, config);
    return response;
  } catch (error) {
    console.error('Update Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to update equipment',
    };
  }
};
/**
 * Delete equipment
 * @param {number|string} equipmentId - The equipment ID
 * @returns {Promise<Object>} { success, data, error }
 */
export const deleteEquipment = async (equipmentId) => {
  try {
    const response = await api.delete(`${API_ENDPOINTS.EQUIPMENT.DELETE}/${equipmentId}`);
    return response;
  } catch (error) {
    console.error('Delete Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to delete equipment',
    };
  }
};

/**
 * Assign equipment to crew/project
 * @param {Object} assignmentData - Assignment details { equipment_id, crew_id?, project_id?, assigned_to?, assignment_date?, return_date? }
 * @returns {Promise<Object>} { success, data: assignment details, error }
 */
export const assignEquipment = async (assignmentData) => {
  try {
    const response = await api.post(API_ENDPOINTS.EQUIPMENT.ASSIGN, assignmentData);
    return response;
  } catch (error) {
    console.error('Assign Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to assign equipment',
    };
  }
};

/**
 * Return equipment from assignment
 * @param {Object} returnData - Return details { equipment_id, return_date?, notes? }
 * @returns {Promise<Object>} { success, data: return details, error }
 */
export const returnEquipment = async (returnData) => {
  try {
    const response = await api.post(API_ENDPOINTS.EQUIPMENT.RETURN, returnData);
    return response;
  } catch (error) {
    console.error('Return Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to return equipment',
    };
  }
};

/**
 * Fetch equipment grouped by location
 * @returns {Promise<Object>} { success, data: equipment grouped by location, error }
 */
export const getEquipmentByLocation = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.EQUIPMENT.BY_LOCATION);
    return response;
  } catch (error) {
    console.error('Get Equipment By Location Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment by location',
    };
  }
};

/**
 * Fetch all equipment
 * @returns {Promise<Object>} { success, data: [equipment items], error }
 */
export const getCrew = async (searchText = "") => {
  try {
    const response = await api.get(API_ENDPOINTS.CREW.GET_NAMES, {
      params: {
        query: searchText,  // 🔥 attaches ?query=value
      },
    });

    return response;
  } catch (error) {
    console.error("Get All Crew Error:", error);
    return {
      success: false,
      data: null,
      error: "Failed to fetch Crew",
    };
  }
};


export const getDashboardDetail = async (filters = {}) => {
  try {
    // Send filters as the POST body
    const response = await api.post(API_ENDPOINTS.CREATOR.DASHBOARD_DETAIL, filters, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response;
  } catch (error) {
    return { success: false, error: 'Failed' };
  }
};


/**
 * Fetch dynamic status counts
 * @param {number|string} creatorId - The creator/crew member ID
 * @returns {Promise<Object>} { success, data: status counts, error }
 */
export const getStatusCount = async (creatorId) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.STATUS_COUNT, {
      creator_id: creatorId
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Get Status Count Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch status counts',
    };
  }
};


/**
 * Equipment autocomplete search
 * @param {string} query - Search query
 * @returns {Promise<Object>}
 */
export const getEquipmentAutocomplete = async (query = '') => {
  try {
    const response = await api.get(API_ENDPOINTS.CREATOR.EQUIPMENT_AUTOCOMPLETE, {
      params: { query },
    });
    return response;
  } catch (error) {
    console.error('Equipment Autocomplete Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment suggestions',
    };
  }
};

/**
 * Create new creator equipment
 * @param {Object} data - Equipment data
 * @returns {Promise<Object>}
 */
export const createCreatorEquipment = async (data) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.MANAGEMENT, data);
    return response;
  } catch (error) {
    console.error('Create Creator Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to create equipment',
    };
  }
};

/**
 * Edit creator equipment
 * @param {Object} data - Equipment data
 * @returns {Promise<Object>}
 */
export const editCreatorEquipment = async (data) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.MANAGEMENT, data);
    return response;
  } catch (error) {
    console.error('Edit Creator Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to update equipment',
    };
  }
};

/**
 * Delete creator equipment
 * @param {number|string} crewEquipmentId - The crew equipment ID
 * @returns {Promise<Object>}
 */
export const deleteCreatorEquipment = async (crewEquipmentId) => {
  try {
    const response = await api.delete(`${API_ENDPOINTS.CREATOR.MANAGEMENT}/${crewEquipmentId}`);
    return response;
  } catch (error) {
    console.error('Delete Creator Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to delete equipment',
    };
  }
};

/**
 * Upload equipment photos
 * @param {number|string} crewEquipmentId - The crew equipment ID
 * @param {File[]} photos - Array of photo files
 * @returns {Promise<Object>}
 */
export const uploadEquipmentPhotos = async (crewEquipmentId, photos) => {
  try {
    const formData = new FormData();
    photos.forEach((photo) => {
      formData.append('photos[]', photo);
    });

    const response = await api.post(
      `${API_ENDPOINTS.CREATOR.MANAGEMENT}/${crewEquipmentId}/photos`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Upload Equipment Photos Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to upload photos',
    };
  }
};

export const UploadFeaturedWork = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.UPLOAD_RECENT_WORK, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    console.error('Failed To Upload Recent Work:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to upload recent work',
    };
  }
};


export const UploadPortfolio = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.UPLOAD_PORTFOLIO, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    console.error('Failed To Upload Recent Work:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to upload recent work',
    };
  }
};

export const UploadCertificate = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.UPLOAD_CERTIFICATION, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    console.error('Failed To Upload Recent Work:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to upload recent work',
    };
  }
};

export const UploadResume = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.UPLOAD_RESUME, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    console.error('Failed To Upload Recent Work:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to upload recent work',
    };
  }
}


export const deleteFiles = async (fileId) => {
  try {
    const response = await api.delete(`${API_ENDPOINTS.CREATOR.DELETE_FILES}/${fileId}`);
    return response;
  } catch (error) {
    console.error('Delete File Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to delete File',
    };
  }
};

export const getRecentActivity = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.CREATOR.RECENT_ACTIVITY, {
    });
    return response;
  } catch (error) {
    console.error('Equipment Autocomplete Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment suggestions',
    };
  }
};


export const requestEquipment = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.SUBMIT_EQUIPMENT_REQUEST, payload);
    return response;
  } catch (error) {
    console.error('Request Equipment Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to request equipment',
    };
  }
};

export const getMyRequest = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.CREATOR.GET_MY_REQUESTS, {
    });
    return response;
  } catch (error) {
    console.error('Equipment Autocomplete Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to fetch equipment suggestions',
    };
  }
};

export const deleteCreatorEquipmentPhoto = async (payload) => {
  try {
    const response = await api.post(API_ENDPOINTS.CREATOR.DELETE_EQUIPMENT_PHOTO, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Delete Equipment Photo Error:', error);
    return {
      success: false,
      data: null,
      error: 'Failed to delete equipment photo',
    };
  }
};
